<template>
    <div class="wrapper">
        <el-form :model="form" ref="form" :rules="rules" style="width: 96%;margin: 10px auto">
            <el-form-item :label="pageType">
            </el-form-item>
            <el-form-item :label="$t('mis.emailTemplate.templateName')" prop="templateName" style="display: flex;">
                <el-input v-model="form.templateName" style="width: 200%;" :disabled="isView"></el-input>
            </el-form-item>
            <el-form-item :label="$t('mis.emailTemplate.title')" prop="title" style="display: flex;">
                <el-input v-model="form.title" style="width: 200%;" :disabled="isView"></el-input>
            </el-form-item>
            <editormd  ref="editormdRef" :emdData="emdData" :disabled="isView"></editormd>
        </el-form>
        <template  slot="footer" style="display: flex;justify-content: center;align-items: center;width: 100%">
            <el-button @click="backToList()" >{{$t('page.cancel')}}</el-button>
            <el-button type="primary" @click="submit('form')" v-if="allowSubmit && !isView">{{$t('page.submit')}}</el-button>
        </template>
    </div>
</template>

<script>
    import DataUtil from '@/views/mis/util/data'
    import editormd from "@/components/page/editor_md.vue"

    //接口地址url的统一管理
    import URL from '@/views/mis/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import axios from 'axios'
    import { getToken } from '@/utils/auth'
    import { getQueryString } from '@/utils/tools'

    export default {
        name: 'edit',
        components: {
            editormd
        },
        mounted(){
            this.pageType = window.$t('page.add')+window.$t('mis.emailTemplate.emailTemplate');
            if (this.$route.query.id){         
                this.pageType = window.$t('page.update')+window.$t('mis.emailTemplate.emailTemplate');   
                let formData = new FormData();
                formData.append("id",this.$route.query.id);
                axios.post(URL.email.getEmailTemplateById,formData,{
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': getToken(getQueryString('label')),
                        },
                    }).then(
                        res=>{
                            if(res.data.code==0){
                                this.form = res.data.result;
                                //console.log(this.form.contentMd);
                                let contentMd = this.form.contentMd;
                                /*
                                this.emdData.editorConfig.onload = function() {
                                    //console.log('onload', this);
                                    this.setMarkdown(contentMd);
                                };
                                */
                                //用onload有時不能setMarkdown, 所以用setTimeout 1秒後setMarkdown
                                setTimeout(() => {  this.initMd(contentMd); }, 1000);

                            }else{
                                this.$message.error(res.data.message);
                                this.backToList();
                            }
                        },err =>{
                            this.$message.error(err.message);
                            this.backToList();
                        }
                    );
            } else {
                this.allowSubmit = true;
            }
            if (this.$route.query.view) {
                this.isView = true;
                this.emdData.editorConfig.readOnly = true;
                this.pageType = window.$t('mis.bt.view')+window.$t('mis.emailTemplate.emailTemplate');   
            }
        },
        methods: {
           backToList(){
               $("div#tags-view-container span.router-link-active span.el-icon-close").click();
               this.$router.push({path:"/mis/emailTemplate/list",query:{label:"MIS"}});
           },
           /*新增或跟提交数据触发事件*/
            submit(fromName){
                this.$refs[fromName].validate(valid => {
                    if (valid) {
                        let formData = new FormData();
                        for(let key in this.form){
                            formData.set(key,this.form[key]);
                            //console.log(formData.get(key));
                        }
                        let contentMd = this.$refs['editormdRef'].getMarkdown();
                        let contentHtml = this.$refs['editormdRef'].getPreviewedHTML();
                        formData.set("contentMd",contentMd);
                        formData.set("contentHtml",contentHtml);
                        //根据是否包含id更新还是添加
                        axios.post(URL.email.addOrUpdateTemplate,formData,{
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                'Authorization': getToken(getQueryString('label')),
                            },
                        }).then(
                            res=>{
                                if(res.data.code==0){
                                    this.$message.success("suc");
                                    this.backToList();
                                }else{
                                    this.$message.error(res.data.message);
                                }
                            },err =>{
                                this.$message.error(err.message);
                            }
                        );
                    }
                });               
            },
            initMd(content) {
                //console.log("initMd");
                this.$refs['editormdRef'].setMarkdown(content);
                this.allowSubmit = true;
            }
        },
        data () {
            return {
                pageType: '',
                isView: false,     
                allowSubmit: false,          
                emdData: {
                    editorPath: '/editormd/',
                    editorConfig: {
                            path: '/editormd/lib/',   // Autoload modules mode, codemirror, marked... dependents libs path
                            width            : "100%",
                            height           : 640,
                            imageUpload      : true,
                            crossDomainUpload: true,
                            imageUploadURL   : URL.email.uploadImgForEmail,
                            toolbarAutoFixed : false,
                            readOnly         : false,
                            onload           : function() {},
                    },			
                },
                form:{
                    id: '',
                    templateName: '',
                    title: '',
                },
                rules: {
                    templateName: [
                    { required: true, message: "模板名称不能为空", trigger: "blur" }
                    ],
                    title: [
                    { required: true, message: "邮件标题不能为空", trigger: "blur" }
                    ],
                },
            }
        }
    }
</script>

<style>
  li {
    list-style: inherit;
  }
</style>
